import "./Header.scss";

const Header = () => {
    return (
        <header className="header">
            <h1 className="header__title">PUNK BEERS</h1>
            <h2 className="header__subtitle">LEARN ABOUT BREWDOG'S CRAFT BEERS</h2>
        </header>
    );
};

export default Header;
